export default "__VITE_ASSET__BQ4OFB2g__"